import styled, { keyframes } from "styled-components";

const moveBackground = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

export const Container = styled.div`

 a {
  text-decoration: none;
 }
`

export const Button = styled.div`
  width: 100%;
  font-family: 'Sora', sans-serif;
  cursor: pointer;
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.72);
  padding: 22px 60px;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 18px;
  border: none;
  color: #fff;
  text-decoration: none;  
  background: linear-gradient(90deg, #0D9F48, #388E3C, #2C6B31, #1B5E20);
box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 255, 0, 0.5);
  background-size: 700% 400%;
  animation: ${moveBackground} 5s ease infinite; /* Aplica ambas as animações */
  text-align: center;


  &:hover {
    animation: none; /* Reaplica a animação zoomIn no hover */
  }

  &:focus {
    outline: none;
  }
`;
